import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP6ChurnedOvw202506: FaireAdPerformancePeriodEntity = {
  token: "perf_p6_churned_ovw_202506",
  type: "adPerformancePeriod",
  scope: "OVERVIEW",
  periodType: "RECEIPT",
  startDate: "2025-06-01",
  endDate: "2025-06-30",
  impressions: 46792,
  clicks: 933,
  adsSpendDollars: 1503,
  budgetDollars: 2400,
  salesDollars: 6668,
  bestEstimateRoas: 4.44,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.63,
  newCustomersAcquired: 12,
  reorderConversions: 5,
  dataAvailableAtDate: "2025-07-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
